import { injectAtomInstance } from './injectAtomInstance.js';
export const injectAtomState = (atom, params) => {
    const instance = injectAtomInstance(atom, params, {
        operation: 'injectAtomState',
        subscribe: true,
    });
    return [instance.getState(), instance._infusedSetter];
};
